import { render, staticRenderFns } from "./PopUpMore18.vue?vue&type=template&id=4257083a&scoped=true&"
import script from "./PopUpMore18.vue?vue&type=script&lang=js&"
export * from "./PopUpMore18.vue?vue&type=script&lang=js&"
import style0 from "./PopUpMore18.vue?vue&type=style&index=0&id=4257083a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4257083a",
  null
  
)

export default component.exports